// extracted by mini-css-extract-plugin
export var discountConditionMoreWidget = "discount-condition-list-module--discount-condition-more-widget--da2fd";
export var labelButton = "discount-condition-list-module--label-button--9c10c";